/* eslint-disable no-unused-expressions */
import axios from "axios"
import normalize from "json-api-normalizer"

export const getCustomLists = (baseUrl, data = {}) => {
  const path = `${baseUrl}/custom_lists`
  return axios.get(path, { params: data })
    .then(({ data, status }) => ({
      response: {
        data: normalize(data),
        ids: _.get(data, "meta.order", [])
      },
      status
    }))
    .catch(error => { error })
}

export const getCustomListById = (baseUrl, customListId) => {
  const path = `${baseUrl}/custom_lists/${customListId}`

  return axios.get(path, { params: {} })
    .then(({ data, status }) => ({ response: normalize(data), status }))
    .catch(error => { error })
}

export const getCustomListRecords = (baseUrl, customListId, data = {}) => {
  const path = `${baseUrl}/custom_lists/${customListId}/records`

  return axios.get(path, { params: data })
    .then(({ data, status }) => ({
      response: {
        data: normalize(data),
        ids: _.get(data, "meta.order", [])
      },
      status
    }))
    .catch(error => { error })
}